import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import Card from "@material-ui/core/Card"
import Button from "@material-ui/core/Button"
import copy from "copy-to-clipboard"
import { withStyles } from "@material-ui/core/styles"
import { withSnackbar } from "notistack"

const styles = theme => ({
	root: {
		margin: theme.spacing ( 2 ),
		display: "flex",
		flexDirection: "column",
		width: 365,
		height: 365,
		boxShadow: theme.shadows [ 1 ],
		backgroundSize: 20,
		backgroundImage: `url(/static/patterns/checkerboard.svg)`,
		"&:hover": {
			boxShadow: theme.shadows [ 3 ]
		},
		[theme.breakpoints.down ("md")]: {
			width: "100%",
		}
	},
	header: {
		display: "flex",
		height: 50,
		alignItems: "center",
		padding: `${theme.spacing ( 2 )}px`,
		backgroundColor: theme.palette.background.paper
	},
	name: {
		fontSize: "1rem",
		flexGrow: 1
	},
	content: {
		flexGrow: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		padding: theme.spacing ( 2 ),
		width: "100%",
		backgroundSize: "contain",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat"
	}
})

class Logo extends React.Component {

	render () {
		const { classes, source, name, background, enqueueSnackbar } = this.props
		return <Card className={classes.root} elevation={0} >
			<div className={classes.header} >
				<Typography className={classes.name} variant="h6" >
					{name.toUpperCase ()}
				</Typography>
				<Button
					size="small"
					color="primary"
					className={classes.button}
					onClick={() => {
						const url = new URL ( window.location )
						copy (`${url.origin}/${source.replace ( /^\/+/m, "" )}`)
						enqueueSnackbar ("Copied to clipboard!")
					}} >
					copy
				</Button>
				<Button
					size="small"
					color="primary"
					className={classes.button}
					onClick={() => {
						window.open ( source )
						enqueueSnackbar ("Opened in new tab!")
					}} >
					open
				</Button>
			</div>
			<div
				className={classes.content}
				style={{
					backgroundImage: `url(${source})`,
					backgroundColor: background
				}}
			/>
		</Card>
	}

}

Logo.propTypes = {
	classes: PropTypes.object.isRequired,
	enqueueSnackbar: PropTypes.func.isRequired,
	source: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	background: PropTypes.string
}

Logo.defaultProps = {
	background: "transparent"
}

export default withSnackbar ( withStyles ( styles ) ( Logo ) )
